import { useTranslation } from "react-i18next";

const WhoWe = () => {
  const phrase = "WE ARE BLUFF      ";
  const { t } = useTranslation();

  return (
    <section className="whowe content-fix-index" id="aboutus">
      <div className="whowe__container">
        <div className="whowe__first">
          <div className="whowe__first_title">{t('whoWeTitle')}</div>
          <div className="whowe__first_info whowe__first_info-first">{t('whoWeTextFirst')}</div>
          <div className="whowe__first_info whowe__first_info-second">{t('whoWeTextSecond')}</div>
        </div>

        <div className="whowe__second">
          <div className="whowe__second_block">
            <div className="whowe__second_block_item">{t('whoWeTextItems', { returnObjects: true })[0]}</div>
            <div className="whowe__second_block_item">{t('whoWeTextItems', { returnObjects: true })[1]}</div>
            <div className="whowe__second_block_item">{t('whoWeTextItems', { returnObjects: true })[2]}</div>
            <div className="whowe__second_block_item">{t('whoWeTextItems', { returnObjects: true })[3]}</div>
          </div>
          <div className="whowe__second_block">
            <div className="whowe__second_block_item">{t('whoWeTextItems', { returnObjects: true })[4]}</div>
            <div className="whowe__second_block_item">{t('whoWeTextItems', { returnObjects: true })[5]}</div>
            <div className="whowe__second_block_item">{t('whoWeTextItems', { returnObjects: true })[6]}</div>
            <div className="whowe__second_block_item">{t('whoWeTextItems', { returnObjects: true })[7]}</div>
          </div>
        </div>
      </div>

      <div className="whowe__animation">
        <div className="whowe__animation_content">
          <div className="whowe__animation_row row1">
            <div className="whowe__animation_track">{phrase.repeat(20)}</div>
          </div>

          <div className="whowe__animation_row row1 offset">
            <div className="whowe__animation_track offset">LUFF      {phrase.repeat(19)}WE ARE B</div>
          </div>

          <div className="whowe__animation_row row1">
            <div className="whowe__animation_track">{phrase.repeat(20)}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWe;